import React from "react";
import { useSelector } from "react-redux";

const BrandLoader = ({
  show = true,
  label = "Loading",
  sublabel = "Preparing your premium experience...",
}) => {
  const logo = useSelector(
    (store) => store?.configs?.admin_conditions?.website_logo
  );

  if (!show) return null;

  return (
    <div className="gp-brand-loader" role="status" aria-live="polite">
      <div className="gp-brand-loader-inner">
        <div className="gp-brand-loader-ring">
          <span className="gp-brand-loader-ring-arc" />
          {logo ? (
            <img src={logo} alt="GlobalGiftPass" className="gp-brand-loader-logo" />
          ) : (
            <span className="gp-brand-loader-mark">GP</span>
          )}
        </div>

        <div className="gp-brand-loader-text">
          <div className="gp-brand-loader-label">{label}</div>
          <div className="gp-brand-loader-sub">{sublabel}</div>
        </div>

        <div className="gp-brand-loader-bar">
          <span className="gp-brand-loader-bar-fill" />
        </div>
      </div>

      <style>{`
        .gp-brand-loader {
          position: fixed;
          inset: 0;
          z-index: 4000;
          display: flex;
          align-items: center;
          justify-content: center;
          background:
            radial-gradient(circle at 30% 20%, rgba(212, 168, 87, 0.18), transparent 45%),
            radial-gradient(circle at 70% 80%, rgba(212, 168, 87, 0.10), transparent 50%),
            linear-gradient(135deg, #0b0b0c 0%, #15110a 100%);
          backdrop-filter: blur(6px);
          animation: gp-bl-fadein .25s ease;
        }
        @keyframes gp-bl-fadein {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .gp-brand-loader-inner {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 22px;
          padding: 36px;
          text-align: center;
        }

        .gp-brand-loader-ring {
          position: relative;
          width: 110px;
          height: 110px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          background: rgba(212, 168, 87, 0.05);
          border: 1px solid rgba(212, 168, 87, 0.2);
        }
        .gp-brand-loader-ring::before,
        .gp-brand-loader-ring::after {
          content: "";
          position: absolute;
          inset: -6px;
          border-radius: 50%;
          border: 2px solid transparent;
          pointer-events: none;
        }
        .gp-brand-loader-ring::before {
          border-top-color: #d4a857;
          border-right-color: rgba(212, 168, 87, 0.4);
          animation: gp-bl-spin 1.2s cubic-bezier(0.65, 0, 0.35, 1) infinite;
        }
        .gp-brand-loader-ring::after {
          inset: -14px;
          border-top-color: rgba(212, 168, 87, 0.25);
          border-left-color: rgba(212, 168, 87, 0.4);
          animation: gp-bl-spin 2.2s cubic-bezier(0.65, 0, 0.35, 1) infinite reverse;
        }
        @keyframes gp-bl-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .gp-brand-loader-ring-arc {
          position: absolute;
          inset: -6px;
          border-radius: 50%;
          box-shadow: 0 0 36px rgba(212, 168, 87, 0.35);
          pointer-events: none;
        }
        .gp-brand-loader-logo {
          width: 56px;
          height: 56px;
          object-fit: contain;
          filter: drop-shadow(0 2px 6px rgba(0,0,0,0.4));
          animation: gp-bl-pulse 1.6s ease-in-out infinite;
        }
        .gp-brand-loader-mark {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: 30px;
          font-weight: 700;
          background: linear-gradient(135deg, #f1cf85, #b58a3f);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          letter-spacing: 1px;
          animation: gp-bl-pulse 1.6s ease-in-out infinite;
        }
        @keyframes gp-bl-pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(0.92); opacity: 0.85; }
        }

        .gp-brand-loader-text {
          color: #fff;
        }
        .gp-brand-loader-label {
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 2.4px;
          text-transform: uppercase;
          color: #d4a857;
        }
        .gp-brand-loader-sub {
          margin-top: 6px;
          font-size: 13px;
          color: #9aa0a8;
          letter-spacing: 0.4px;
        }

        .gp-brand-loader-bar {
          width: 220px;
          height: 3px;
          border-radius: 999px;
          background: rgba(212, 168, 87, 0.15);
          overflow: hidden;
        }
        .gp-brand-loader-bar-fill {
          display: block;
          width: 40%;
          height: 100%;
          background: linear-gradient(90deg, transparent, #d4a857, transparent);
          animation: gp-bl-bar 1.4s ease-in-out infinite;
        }
        @keyframes gp-bl-bar {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(280%); }
        }

        @media (max-width: 480px) {
          .gp-brand-loader-ring { width: 90px; height: 90px; }
          .gp-brand-loader-logo { width: 46px; height: 46px; }
          .gp-brand-loader-label { font-size: 14px; letter-spacing: 2px; }
          .gp-brand-loader-sub { font-size: 12px; }
          .gp-brand-loader-bar { width: 180px; }
        }
      `}</style>
    </div>
  );
};

export default BrandLoader;
